import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {reset} from 'redux-form';

import CommentsList from './CommentsList';
import CommentForm from '../components/CommentForm';
import { addSubmissionComment } from 'Actions/submission';
import { aclDecorator } from 'Decorators';
import { ROLE_ADMIN, ROLE_AUTHOR, ROLE_CHIEF_EDITORIAL, ROLE_EDITORIAL } from 'Constants';

@connect(null, dispatch => ({
    addSubmissionComment: (data) => dispatch(addSubmissionComment(data)),
    reset: (form) => dispatch(reset(form))
}))
@aclDecorator()
export default class Comments extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        submissionId: PropTypes.number.isRequired,
        addSubmissionComment: PropTypes.func.isRequired,
        reset: PropTypes.func,
        isOneOf: PropTypes.func.isRequired,
    };

    onSubmit = (data) => {
        const { addSubmissionComment, submissionId, reset } = this.props;
        addSubmissionComment({
            ...data,
            submission_id: submissionId,
        });
        reset('submissionComment');
    };

    render () {
        const { submissionId, isOneOf } = this.props;
        const showForm = isOneOf([ROLE_AUTHOR, ROLE_EDITORIAL, ROLE_CHIEF_EDITORIAL, ROLE_ADMIN]);

        return (
            <div>
                { showForm &&
                    <CommentForm onSubmit={ this.onSubmit } />
                }
                <CommentsList submissionId={submissionId} showEmptyMsg={!showForm} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/containers/Comments.jsx